import { inject, Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { flatMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

import * as fromActions from './favorite-btn.actions';
import { FavoriteBtnService } from '../favorite-btn.service';
import { Delivery } from '../../../../../../core/models';

@Injectable()
export class FavoriteBtnEffects {
  actions$ = inject(Actions);
  favoriteBtnService = inject(FavoriteBtnService);

  removeFavoriteBtn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.removeFavorite),
      flatMap((resp: { deliveryKeyCode: string }) => (
        this.favoriteBtnService.removeFavorite(resp.deliveryKeyCode).pipe(
          map(() =>
            fromActions.removeFavoriteSuccess({
              deliveryKeyCode: resp.deliveryKeyCode,
            }),
          ),
          catchError(() => of(fromActions.removeFavoriteFail())),
        )
      )),
    ),
  );

  addToFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.addToFavorite),
      flatMap((resp: { delivery: Delivery }) => {
        const { delivery } = resp;
        return this.favoriteBtnService.addFavorite(delivery.deliveryKeyCode).pipe(
          map(() => fromActions.addToFavoriteSuccess({ delivery })),
          catchError(() => of(fromActions.addToFavoriteFail())),
        );
      }),
    ),
  );
}
